import React from "react";
import "./Achievements.css";
import { FaTrophy, FaMedal, FaAward } from "react-icons/fa";
import winningPhoto from "../images/winning-photo.jpeg";

interface Achievement {
  title: string;
  event: string;
  prize: string;
  description: string;
  date: string;
  image?: string;
  icon: React.ReactNode;
}

const achievements: Achievement[] = [
  {
    title: "National Winner",
    event: "Allianz Tech Championship 2024",
    prize: "€3,000",
    description:
      "Selected as a National Winner from 25,000+ participants across India. After clearing three competitive online rounds, I presented a framework for measuring and managing the environmental impact of AI applications to Allianz representatives at my college. Was felicitated at Allianz headquarters along with my family.",
    date: "2024",
    image: winningPhoto,
    icon: <FaTrophy />,
  },
];

const Achievements: React.FC = () => {
  return (
    <div className="achievements-container">
      <h1 className="achievements-title">
        <FaAward className="title-icon" /> Achievements
      </h1>
      <p className="achievements-subtitle">Recognition & Awards</p>

      <div className="achievements-grid">
        {achievements.map((achievement, index) => (
          <div
            key={index}
            className="achievement-card featured"
            style={{ "--delay": `${index * 0.2}s` } as React.CSSProperties}
          >
            <div className="achievement-badge">{achievement.icon}</div>

            {achievement.image && (
              <div className="achievement-image-container">
                <img
                  src={achievement.image}
                  alt={achievement.title}
                  className="achievement-image"
                />
              </div>
            )}

            <div className="achievement-content">
              <div className="achievement-header">
                <h2>{achievement.title}</h2>
                <span className="achievement-date">{achievement.date}</span>
              </div>

              <h3 className="achievement-event">{achievement.event}</h3>

              <div className="achievement-prize">
                <FaMedal className="prize-icon" />
                <span>{achievement.prize}</span>
              </div>

              <p className="achievement-description">
                {achievement.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="achievements-cta">
        <p>
          More achievements coming soon as I continue to participate in
          competitions and build innovative solutions!
        </p>
      </div>
    </div>
  );
};

export default Achievements;
